module.exports = __webpack_public_path__ + "static/media/copa-america.7f44c2cb.png";